<template>
  <svg width="17" height="22" viewBox="0 0 17 22" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M15.7857 8.81674H4.85714V5.63078C4.85714 3.98287 6.07143 2.55469 7.77143 2.2251C10.0786 1.89552 12.1429 3.43357 12.1429 5.52092C12.1429 6.18008 12.75 6.61953 13.3571 6.61953C13.9643 6.61953 14.5714 6.18008 14.5714 5.52092C14.5714 2.33497 11.5357 -0.301687 7.89286 0.0278943C4.73571 0.357476 2.42857 2.88427 2.42857 5.74064V8.81674H1.21429C0.607143 8.81674 0 9.25618 0 9.91534V20.9014C0 21.4507 0.607143 22 1.21429 22H15.7857C16.5143 22 17 21.4507 17 20.9014V9.91534C17 9.25618 16.5143 8.81674 15.7857 8.81674ZM9.71429 16.1774V17.6056C9.71429 18.2647 9.22857 18.7042 8.5 18.7042C7.77143 18.7042 7.28571 18.2647 7.28571 17.6056V16.1774C6.55714 15.7379 6.07143 15.0788 6.07143 14.3098C6.07143 12.8816 7.52857 11.8928 9.10714 12.2224C9.95714 12.4421 10.6857 13.1013 10.9286 13.8703C11.1714 14.8591 10.5643 15.7379 9.71429 16.1774Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconLockOpen"
}
</script>

<style scoped>

</style>